<template>
  <editor-content
    v-if="part=='title'"
    :editor="editorTitle"
  />
  <editor-content
    v-else-if="part=='description'"
    :editor="editorDescription"
  />
  <editor-content
    v-else
    :editor="editorImage"
  />
</template>
<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import TextStyle from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Bold from '@tiptap/extension-bold'
import Italic from '@tiptap/extension-italic'
import Underline from '@tiptap/extension-underline'
import BulletList from '@tiptap/extension-bullet-list'
import OrderedList from '@tiptap/extension-ordered-list'
import ListItem from '@tiptap/extension-list-item'
import FontSize from './editor_extensions/font-size.js'
//import Div from './editor_extensions/div.js'
import Strike from '@tiptap/extension-strike'
import Focus from '@tiptap/extension-focus'
import HardBreak from '@tiptap/extension-hard-break'
import History from '@tiptap/extension-history'
import Placeholder from '@tiptap/extension-placeholder'
import i18n from '../plugins/i18n.js'
import CustomImage from './editor_extensions/custom-image.js'
import CustomLink from './editor_extensions/custom-link.js'

export default {
    components: {
        EditorContent
    },
    props:{
        content: {
          type: String,
          default: ''
        },
        index: {
          type: Number,
          default: 0
        },
        part: {
          type: String,
          default: 'description'
        },
        screen: {
          type: String,
          default: ''
        },
        answerIndex: {
          type: Number,
          default: 0
        },
        type: {
          type: String,
          default: ''
        },
        placeholder:{
          type: String,
          default: ''
        }
    },
    data(){
      return{
        editorTitle: null,
        editorDescription: null,
        editorImage: null,
        oldContent: this.content,
      }
    },
    created(){
    },
    mounted() {
      //override paragraph node - was not working in separate file
      const CustomParagraph = Paragraph.extend({
        addAttributes() {
          return {
            class: {
                default: '',
                rendered: true
            }
          }
        },
        addCommands() {
          return {
            setParagraph: attributes => ({ commands }) => {
              return commands.setNode('paragraph', attributes);
            },
          }
        }
      })

      const CustomTextStyle = TextStyle.extend({
        addAttributes() {
          return {
            class: {
                default: '',
                rendered: true
            }
          }
        },
      })

    this.editorTitle = new Editor({
      editorProps: {
        handleClick: ( ) => {
          this.setActiveEditor(this.editorTitle)
        },
        handleDoubleClick: ( ) => {
            this.editorTitle.setEditable(true)
            this.$emit('enableEditMode')
        },
        handleDOMEvents: {
            drop: (view, e) => { e.preventDefault(); },
        },
        transformPastedHTML: (html) => {
            return html.replace(/<img .*?>/g,'').replace(/<iframe .*?>/g,''); 
        }
      },
      // hide the drop position indicator
      dropCursor: { width: 0, color: 'transparent' },
      extensions: [
        Document,
        Text,
        CustomParagraph.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        CustomTextStyle,
        Color,
        FontSize,
        Focus.configure({
          className: 'has-focus',
          mode: 'deepest'
        }),
        History,
        HardBreak,
        Placeholder.configure({
          includeChildren: true,
          showOnlyWhenEditable: false,
          placeholder: ({ node, editor }) => {
            if (node.type.name === 'paragraph') {
              if(editor.state.doc.textContent.length === 0){
                if(this.screen == ''){
                  return (this.index+1) + '. ' + i18n.t(this.placeholder)
                }else{
                  return i18n.t('surveyStartEndTitlePlaceholder')
                }
              }
            }
            return null
          },
        }),
        CustomLink.configure({
          openOnClick: false,
          HTMLAttributes: {
            target: '_blank',
          },
        }),
        //Div
      ],
      content: this.content,
      //editable: false,
      onUpdate: ({ editor}) => {
        const newContent = editor.getHTML()
        this.$emit('updateSurvey',this.index, newContent)
      },
      onSelectionUpdate: ({ editor}) => {
        this.$emit('proceedClick',editor)
        const { view: { state: { tr: { selection } } } } = editor
        this.$emit('proceedMark', !selection.empty)
      },
      onBlur: () => {
        this.$emit('showErrorMessage', this.index)
      }
    }),
    this.editorDescription = new Editor({
      editorProps: {
        handleClick: ( ) => {
          this.setActiveEditor(this.editorDescription)
        },
        handleDoubleClick: ( ) => {
            this.editorDescription.setEditable(true)
            this.$emit('enableEditMode')
        },
        handleDOMEvents: {
            drop: (view, e) => { e.preventDefault(); },
        },
        transformPastedHTML: (html) => {
            return html.replace(/<img .*?>/g,'').replace(/<iframe .*?>/g,''); 
        }
      },
      // hide the drop position indicator
      dropCursor: { width: 0, color: 'transparent' },
      extensions: [
        Document,
        Text,
        Bold,
        Italic,
        Underline,
        Strike,
        Highlight,
        BulletList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        OrderedList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        ListItem,
        CustomParagraph.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
         CustomTextStyle,
        Color,
        FontSize,
        Focus.configure({
          className: 'has-focus',
          mode: 'deepest'
        }),
        History,
        HardBreak,
        Placeholder.configure({
          includeChildren: true,
          showOnlyWhenEditable: false,
          placeholder: ({ node, editor }) => {
            if (node.type.name === 'paragraph') {
              if(editor.state.doc.textContent.length === 0){
                if(this.screen == ''){
                  return i18n.t('surveyDescriptionPlaceholder')
                }else{
                  return i18n.t('surveyStartEndDescriptionPlaceholder')
                }
              }
            }
            return null
          },
        }),
        CustomLink.configure({
          openOnClick: false,
          HTMLAttributes: {
            target: '_blank',
          },
        }),
        //Div
      ],
      content: this.content,
      //editable: false,
      onUpdate: ({ editor}) => {
        const newContent = editor.getHTML()
        this.$emit('updateSurvey',this.index, newContent)
      },
      onSelectionUpdate: ({ editor}) => {
        this.$emit('proceedClick',editor)
        const { view: { state: { tr: { selection } } } } = editor
        this.$emit('proceedMark', !selection.empty)
      },
    }),
    this.editorImage = new Editor({
      editorProps: {
        handleClick: ( ) => {
          this.setActiveEditor(this.editorImage)
        },
        handleDoubleClick: ( ) => {
            this.editorImage.setEditable(true)
            this.$emit('enableEditMode')
        },
        handleDOMEvents: {
            drop: (view, e) => { e.preventDefault(); },
            paste: (view, e) => {
                /*if(e.target.nodeName == 'IMG'){
                    e.preventDefault();
                }*/
                if(this.editorImage.isActive('custom-image')){
                    e.preventDefault();
                }
            },
            keydown: (view, e) => {
                /*if ((e.key === "Delete" || e.key === "Enter" || e.key == "Backspace") && (this.editorColumnsFirst.isActive('custom-image') || this.editorColumnsFirst.isActive('iframe'))) {
                    e.preventDefault();
                }*/
                if(e.key && (this.editorImage.isActive('custom-image'))){
                    e.preventDefault();
                }
                return false;
            }
        },
        transformPastedHTML: (html) => {
            return html.replace(/<img .*?>/g,'').replace(/<iframe .*?>/g,''); 
        },
        attributes:{
          type: this.type
        }
      },
      // hide the drop position indicator
      dropCursor: { width: 0, color: 'transparent' },
      extensions: [
        Document,
        Text,
        
        Focus.configure({
          className: 'has-focus',
          mode: 'deepest'
        }),
        History,
        HardBreak,
        CustomParagraph.configure({
          HTMLAttributes: {
            class: 'survey-question-image add-transparent-border',
          },
        }),
        CustomImage.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
          //draggable: false
        }),
      ],
      content: this.content,
      //editable: false,
      onUpdate: ({ editor}) => {
        const newContent = editor.getHTML()
        this.$emit('updateSurvey', this.type, this.index, this.answerIndex, newContent)
      },
      onSelectionUpdate: ({ editor}) => {
        this.$emit('proceedClick',editor)
        const { view: { state: { tr: { selection } } } } = editor
        this.$emit('proceedMark', !selection.empty)
      },
      onBlur: () => {
        this.$emit('showErrorMessage', this.index, this.answerIndex, this.type)
      }
    })
  },

  beforeUnmount() {
    this.editorTitle.destroy()
    this.editorDescription.destroy()
    this.editorImage.destroy()
  },
   methods: {
    setActiveEditor(editor){
      this.$emit('proceedClick',editor)
    }
  }
}
</script>